import { Button } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';

type Props = {
  action?: () => void;
  text: string;
  loading?: boolean;
};

const Wrap = styled.div`
  .btn-detail {
    border-radius: 5px;
    background: #a956ea;
    margin-right: 1rem;
    color: white;
    border: 1px solid #a956ea;
  }
  .ant-btn,
  .btn-detail:focus {
    background-color: #a956ea;
  }
`;

const ButtonDetail: FC<Props> = ({ action, text, loading }) => {
  return (
    <Wrap>
      <Button onClick={action} className="btn-detail standardFont" loading={loading} disabled={loading}>
        {text}
      </Button>
    </Wrap>
  );
};

export default ButtonDetail;
